import {
  CLOSE_ERROR,
  CLOSE_MODAL_ERROR,
  SET_SIDE_MENU,
  SET_TOP_MENU,
} from "../constants";
import { getWithNoAuth } from "./axios";
import fileDownload from "js-file-download";

export const closeError = () => async (dispatch) => {
  dispatch({ type: CLOSE_ERROR });
};

export const closemodalError = () => async (dispatch) => {
  dispatch({ type: CLOSE_MODAL_ERROR });
};

export const setSelectTopMenu = (tomMenu) => async (dispatch) => {
  dispatch({ type: SET_TOP_MENU, payload: tomMenu });
};

export const setSelectedSideMenu = (sideMenu) => async (dispatch) => {
  dispatch({ type: SET_SIDE_MENU, payload: sideMenu });
};

export const downloadFile = (fileURL, name) => async (dispatch) => {
  try {
    const result = await getWithNoAuth(
      fileURL,
      {
        responseType: "blob",
      },
      null,
      dispatch
    );
    fileDownload(result, name);
  } catch (error) {
    console.log("Error", error);
  }
};
